import React from 'react'

const nepalPhotos = {
    id: 'nepal-photos',
    type: 'photoPost',
    countryId: 'nepal',
    title: 'Our Nepal Trip in Photos',
    month: 'Feb',
    date: '27',
    content: [
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal1.jpg',
            detailText: (
                <div>The day before our trek began, Peter and I hiked up to Sarankhot from Pokhara. For a full account of our trek, <a href="https://worldofwander.app/post/nepal">read the blog post!</a></div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal2.jpg',
            detailText: 'Moving through the countryside up into the mountains.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal3.jpg',
            detailText: 'Peter and I took a longer route with the guide on the first day, and passed over this slightly terrifying suspension bridge.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal4.jpg',
            detailText: 'The crew at the end of the first day.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal5.jpg',
            detailText: 'A dark and moody first afternoon after arriving in Ghandruk.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal6.jpg',
            detailText: 'The mountains just barely poking through the clouds.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal7.jpg',
            detailText: 'Sunrise our first day - the most glorious for us. We hung around watching it for a long time.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal8.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal9.jpg',
            detailText: 'The donkeys of Ghandruk (that sounds like a Lord of the Rings title...)'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal10.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal11.jpg'],
            detailText: 'Left, Fishtail mountain - considered sacred, and therefore never summited. Right, our teahouse overlooking Fishtail.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal12.jpg',
            detailText: 'These mossy and snowy trees were so cool!'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal13.jpg',
            detailText: 'Sunrise on day 3 from Tadapani.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal14.jpg',
            detailText: 'Towards the end of day 3, mist began to creep up one side of the range and made our walk very moody.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal15.jpg',
            detailText: 'The coolest wall of white.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal16.jpg',
            detailText: 'Everyone else took a victory picture at the highest point of day 3...'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal17.jpg',
            detailText: '... while I collapsed and napped (you can just make me out amidst the bags here).'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal18.jpg',
            detailText: 'Somersaults in the snow (for the talented only).'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal19.jpg',
            detailText: 'The other side of the hill was clear, but this side was shrouded in mist.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal20.jpg',
            detailText: 'This and next four pictures: sunrise from Poon Hill, overlooking the Annapurna mountain range.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal21.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal22.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal23.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal24.jpg',
            detailText: 'Peter alone at Poon Hill (with our two porters behind the camera).'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal25.jpg',
            detailText: 'The peak of the trek – 3210 meters.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal26.jpg',
            detailText: 'A little waterfall passed on our descent on the fourth day.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal27.jpg',
            detailText: 'In the absence of wifi, we played a lot of cards this trip!'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal28.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/nepal/nepal-photos/nepal29.jpg'],
            detailText: 'Left, a mural passed on our first way hiking through the villages up to Ghandruk. Right, Peter and me on Valentine\'s day in Kathmandu after the trek.'
        },
    ]
}

export default nepalPhotos



// WEBPACK FOOTER //
// ./src/Posts/Content/nepalPhotos.js